import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const row: SxStyleFunc<number> = (stickyTop) => ({
  '& > td': {
    position: 'sticky',
    top: stickyTop,
    backgroundColor: 'white', // Prevent overlap issues
    background: (p) => p.palette.primary[50],
    zIndex: 10,
  },
  '& > td:first-of-type': {
    zIndex: 100, // Higher z-index for the first cell
  },

  '& > td:nth-of-type(2)': {
    zIndex: 100, // Higher z-index for the second cell
    boxShadow: 'none',
  },
});

export const stickyRowAnimation: SxStyleFunc<{
  index: number;
  stickyCollapsed: boolean;
}> = ({ index, stickyCollapsed }) => ({
  transition: 'opacity 0.3s ease, transform 0.3s ease',
  transitionDelay: `${index * 100}ms`,
  opacity: stickyCollapsed && index > 0 ? 0 : 1,
  transform:
    stickyCollapsed && index > 0 ? 'translateY(-20px)' : 'translateY(0)',
  pointerEvents: stickyCollapsed && index > 0 ? 'none' : 'auto',
});

export type StickyRowSxArgs = {
  stickyTop: number;
  index: number;
  stickyCollapsed: boolean;
};

export const stickyRow: SxStyleFunc<StickyRowSxArgs> = ({
  stickyTop,
  index,
  stickyCollapsed,
}) => ({
  ...row(stickyTop),
  ...stickyRowAnimation({ index, stickyCollapsed }),
});
